t = require('views/internal/teacup-with-helpers')('org_prefs_vis')
{ featureFlagClient } = require 'common/lib/feature-flag-client'

module.exports = t.renderable (org, enterprise) ->

  enforced = enterprise?.organizationPrefs?.boardVisibilityRestrict

  t.div { class: t.classify('board-visibility-restrict-item': true, disabled: enforced?.public?) }, ->

    t.p ->
      t.format 'who-can-create-public-boards'

    t.ul '.pop-over-list.checkable.left-check.normal-weight', { 'data-vis': 'public' }, ->

      t.li { class: t.classify(active: org.prefs.boardVisibilityRestrict.public == 'org') }, ->
        t.a { href: '#', 'data-restriction': 'org', class: t.classify(disabled: enforced?.public?) }, ->
          t.format 'any-organization-member'

      t.li { class: t.classify(active: org.prefs.boardVisibilityRestrict.public == 'admin') }, ->
        t.a { href: '#', 'data-restriction': 'admin', class: t.classify(disabled: enforced?.public?) }, ->
          t.format 'only-organization-admins'

      t.li { class: t.classify(active: org.prefs.boardVisibilityRestrict.public == 'none') }, ->
        t.a { href: '#', 'data-restriction': 'none', class: t.classify(disabled: enforced?.public?) }, ->
          t.format 'nobody'

  if enforced?.public?
    t.div '.board-visibility-restrict-item', ->
      t.span { class: 'inline-hint' }, ->
        t.format('inherited-setting', enterpriseDisplayName: enterprise.displayName)

  t.hr()

  if featureFlagClient.get('enterprise.company_visible_boards', false) && enterprise
    t.div { class: t.classify('board-visibility-restrict-item': true, disabled: enforced?.enterprise?) }, ->

      t.p ->
        t.format 'who-can-create-enterprise-boards'

      t.ul '.pop-over-list.checkable.left-check.normal-weight', { 'data-vis': 'enterprise' }, ->

        t.li { class: t.classify(active: org.prefs.boardVisibilityRestrict.enterprise == 'org') }, ->
          t.a { href: '#', 'data-restriction': 'org', class: t.classify(disabled: enforced?.enterprise?) }, ->
            t.format 'any-organization-member'

        t.li { class: t.classify(active: org.prefs.boardVisibilityRestrict.enterprise == 'admin') }, ->
          t.a { href: '#', 'data-restriction': 'admin', class: t.classify(disabled: enforced?.enterprise?) }, ->
            t.format 'only-organization-admins'

        t.li { class: t.classify(active: org.prefs.boardVisibilityRestrict.enterprise == 'none') }, ->
          t.a { href: '#', 'data-restriction': 'none', class: t.classify(disabled: enforced?.enterprise?) }, ->
            t.format 'nobody'

    if enforced?.enterprise?
      t.div '.board-visibility-restrict-item', ->
        t.span { class: 'inline-hint' }, ->
          t.format('inherited-setting', enterpriseDisplayName: enterprise.displayName)

    t.hr()

  t.div { class: t.classify('board-visibility-restrict-item': true, disabled: enforced?.org?) }, ->

    t.p ->
      t.format 'who-can-create-org-boards'

    t.ul '.pop-over-list.checkable.left-check.normal-weight', { 'data-vis': 'org' }, ->

      t.li { class: t.classify(active: org.prefs.boardVisibilityRestrict.org == 'org') }, ->
        t.a { href: '#', 'data-restriction': 'org', class: t.classify(disabled: enforced?.org?) }, ->
          t.format 'any-organization-member'

      t.li { class: t.classify(active: org.prefs.boardVisibilityRestrict.org == 'admin') }, ->
        t.a { href: '#', 'data-restriction': 'admin', class: t.classify(disabled: enforced?.org?) }, ->
          t.format 'only-organization-admins'

      t.li { class: t.classify(active: org.prefs.boardVisibilityRestrict.org == 'none') }, ->
        t.a { href: '#', 'data-restriction': 'none', class: t.classify(disabled: enforced?.org?) }, ->
          t.format 'nobody'

  if enforced?.org?
    t.div '.board-visibility-restrict-item', ->
      t.span { class: 'inline-hint' }, ->
        t.format('inherited-setting', enterpriseDisplayName: enterprise.displayName)

  t.hr()

  t.div { class: t.classify('board-visibility-restrict-item': true, disabled: enforced?.private?) }, ->

    t.p ->
      t.format 'who-can-create-private-boards'

    t.ul '.pop-over-list.checkable.left-check.normal-weight', { 'data-vis': 'private' }, ->

      t.li { class: t.classify(active: org.prefs.boardVisibilityRestrict.private == 'org') }, ->
        t.a { href: '#', 'data-restriction': 'org', class: t.classify(disabled: enforced?.private?) }, ->
          t.format 'any-organization-member'

      t.li { class: t.classify(active: org.prefs.boardVisibilityRestrict.private == 'admin') }, ->
        t.a { href: '#', 'data-restriction': 'admin', class: t.classify(disabled: enforced?.private?) }, ->
          t.format 'only-organization-admins'

      t.li { class: t.classify(active: org.prefs.boardVisibilityRestrict.private == 'none') }, ->
        t.a { href: '#', 'data-restriction': 'none', class: t.classify(disabled: enforced?.private?) }, ->
          t.format 'nobody'

  if enforced?.private?
    t.div '.board-visibility-restrict-item', ->
      t.span { class: 'inline-hint' }, ->
        t.format('inherited-setting', enterpriseDisplayName: enterprise.displayName)



// WEBPACK FOOTER //
// ./app/scripts/views/templates/org_prefs_vis.coffee